import moment from 'moment'
import momentTZ from 'moment-timezone'
require('moment/locale/zh-cn');
const Moment = {}

Moment.install = function (Vue) {
  // 本地化，中文时间显示
  moment.locale('zh-cn')
  // 设置时区为金边时间（东7区）
  moment.tz.setDefault('Indian/Christmas')
  momentTZ.tz.setDefault('Indian/Christmas')
  Vue.prototype.moment = moment
}

export default Moment
